import * as React from 'react';
import * as styles from '../styles.scss';
import { Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { INewSymbolData } from 'interfaces/market';
import { SellBuyType } from 'constants/enum';

interface IConfirmSectionProps
  extends React.ClassAttributes<ConfirmComponent>,
    WithNamespaces {
  readonly isDerivatives: boolean;
  readonly isHorizontal: boolean;
  readonly symbol?: INewSymbolData;
  readonly isSubmitDisabled?: boolean;
  readonly sellBuyType: SellBuyType;
  readonly buyType: boolean;
  readonly sellType: boolean;

  readonly onOpenModal: () => void;
}

class ConfirmComponent extends React.Component<IConfirmSectionProps> {
  render() {
    const {
      t,
      symbol,
      isDerivatives,
      isHorizontal,
      isSubmitDisabled,
      sellBuyType,
      buyType,
      sellType,
      onOpenModal,
    } = this.props;
    return (
      <div
        className={classNames(
          styles.ConfirmSection,
          styles.FormField,
          styles.btnNewOrder,
          {
            [styles.DerivativesField]: isDerivatives,
            [styles.Vertical]: !isHorizontal,
            [styles.btnNewOrderHorizontal]: isHorizontal,
          }
        )}
      >
        <div className={styles.MainField}>
          <div className={styles.FieldInput}>
            <div className={styles.SubmitButton}>
              <button
                className={classNames({
                  [styles.BuySubmitButton]: buyType,
                  [styles.SellSubmitButton]: sellType,
                })}
                type="button"
                onClick={onOpenModal}
                disabled={isSubmitDisabled}
              >
                {t(`${sellBuyType} 2`)}
                {` (${symbol?.s})`}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: IState) => ({});

const mapDispatchToProps = {};

const ConfirmSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(ConfirmComponent)
  ),
  Fallback,
  handleError
);

export default ConfirmSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/ConfirmSection.tsx